import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import Loader from './Loader';
import { useFeatureToggle } from '../context';

export default function FeatureToggleBadge() {
  const { id, isLoading, isEnabled, onModalOpen } = useFeatureToggle();

  return (
    <Loader isLoading={isLoading}>
      <div
        className={cn(styles.container, { [styles.active]: isEnabled })}
        onClick={() => onModalOpen(id)}
      >
        <UiKit.Toggle isActive={isEnabled} />
        <span className={styles.label}>Activate</span>
      </div>
    </Loader>
  );
}
